import { Component, ReactNode } from "react";
import { StorageRouterProps } from "../StorageRouterProps";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";
import AssignmentsTable from "../components/AssignmentsTable";
import StorageConnect from "../components/StorageConnect";

export interface StorageViewPageProps extends NSARouterMakerResult, StorageRouterProps { }

class StorageViewPage extends Component<StorageViewPageProps>
{
    override render(): ReactNode
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.storage(this.props),
                    view: {
                        ui: {
                            tab_page_view: {
                                tabs: {
                                    extra: {
                                        after_general: [
                                            {
                                                title: "Connection",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <StorageConnect
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                            {
                                                title: "Assignment",
                                                clicked: false,
                                                isVisible: (model) => !!model.id,
                                                getContent: (model) =>
                                                {
                                                    if (!model.id)
                                                        return null;
                                                    return (
                                                        <AssignmentsTable
                                                            {...this.props}
                                                            storage_id={model.id}
                                                        />
                                                    );
                                                },
                                            },
                                        ],
                                    },
                                },
                            },
                        },
                    }
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default StorageViewPage;